import React from 'react';
import { motion } from 'framer-motion';
import GlassCard from '../UI/GlassCard';
import CyberButton from '../UI/CyberButton';
import HUDElement from '../UI/HUDElement';
import NeonText from '../UI/NeonText';

const ServicesGrid = ({ limit }) => {
    const services = [
        {
            id: 1,
            icon: '🤖',
            title: 'IA & Machine Learning',
            description: 'Desarrollo de sistemas de inteligencia artificial y algoritmos de aprendizaje automático para automatización y análisis predictivo.',
            features: ['Neural Networks', 'Computer Vision', 'NLP', 'Predictive Analytics'],
            stats: { completion: 95, projects: 24 }
        },
        {
            id: 2,
            icon: '🔒',
            title: 'Ciberseguridad',
            description: 'Protección avanzada de sistemas y datos con tecnologías de encriptación quantum y monitoreo en tiempo real.',
            features: ['Quantum Encryption', 'Threat Detection', 'Pentesting', 'Security Audit'],
            stats: { completion: 98, projects: 18 }
        },
        {
            id: 3,
            icon: '🌐',
            title: 'Realidad Extendida',
            description: 'Creación de experiencias inmersivas en VR/AR para entrenamiento, visualización y entretenimiento.',
            features: ['VR Development', 'AR Integration', 'Haptic Feedback', 'Spatial Computing'],
            stats: { completion: 85, projects: 32 }
        },
        {
            id: 4,
            icon: '⛓️',
            title: 'Blockchain & Web3',
            description: 'Implementación de soluciones descentralizadas, smart contracts y aplicaciones DApp.',
            features: ['Smart Contracts', 'DeFi', 'NFT Platforms', 'DApp Development'],
            stats: { completion: 90, projects: 15 }
        },
        {
            id: 5,
            icon: '☁️',
            title: 'Cloud Computing',
            description: 'Arquitecturas escalables en la nube con edge computing y procesamiento distribuido.',
            features: ['Cloud Architecture', 'Edge Computing', 'Microservices', 'DevOps'],
            stats: { completion: 97, projects: 41 }
        },
        {
            id: 6,
            icon: '📱',
            title: 'Neuro-Interfaces',
            description: 'Desarrollo de interfaces cerebro-computadora para control mental de dispositivos.',
            features: ['BCI Development', 'Signal Processing', 'Biofeedback', 'Neural Implants'],
            stats: { completion: 75, projects: 8 }
        }
    ];

    const displayedServices = limit ? services.slice(0, limit) : services;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.6
            }
        }
    };

    return (
        <motion.div
            className="services-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
        >
            {displayedServices.map((service) => (
                <motion.div key={service.id} variants={itemVariants}>
                    <GlassCard className="service-card">
                        <div className="service-card__header">
                            <div className="service-icon">{service.icon}</div>
                            <h3 className="service-title">
                                <NeonText variant="cyan">{service.title}</NeonText>
                            </h3>
                        </div>

                        <p className="service-description">{service.description}</p>

                        <div className="service-stats">
                            <HUDElement
                                label="Eficiencia"
                                value={service.stats.completion}
                                unit="%"
                                variant="compact"
                            />
                            <HUDElement
                                label="Proyectos"
                                value={service.stats.projects}
                                variant="compact"
                            />
                        </div>

                        <div className="service-features">
                            {service.features.map((feature, index) => (
                                <span key={index} className="service-feature">
                  {feature}
                </span>
                            ))}
                        </div>

                        <div className="service-actions">
                            <CyberButton variant="cyan" size="small">
                                Especificaciones
                            </CyberButton>
                            <CyberButton variant="outline" size="small">
                                Casos de Estudio
                            </CyberButton>
                        </div>
                    </GlassCard>
                </motion.div>
            ))}
        </motion.div>
    );
};

export default ServicesGrid;